/*
 * @Author: Musa Tabitay
 * @Date: 2022-04-06 21:16:05
 * @LastEditTime: 2022-04-12 23:17:35
 */
/**
 * 封装 axios 请求模块
 */
import axios from 'axios'
import { _isMobile, getCookie } from '@/utils/util'
import { getItem, setItem } from '@/utils/storage'
import { redirectToAuth } from '@/utils/auth'

const CryptoJS = require('crypto-js')
const Base64 = require('js-base64').Base64

const secretKey = 'rhDaeJnL8x'
const TOKEN_EXPIRED_CODE = 10006 // 服务端约定：token 已过期
const H5_LOGIN_TYPE = 103 // 微信公众号网页登录

const whiteList = []
const instance = axios.create()

// 解密服务端返回的密文
const handleResult = res => {
  const bytes = CryptoJS.AES.decrypt(res, secretKey)
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
}

// 写入 token 请求头
const withToken = (config, token) => {
  if (token) config.headers.Authorization = `Basic ${Base64.encode(`${token}:`)}`
  return config
}

// 用 openId 重新换取 token（单飞：并发只发起一次刷新）
let refreshing = null
const refreshToken = openId => {
  if (!refreshing) {
    refreshing = instance
      .post('/v2/token', { type: H5_LOGIN_TYPE, account: openId })
      .then(({ data }) => {
        if (!data?.token) throw new Error('刷新 token 失败')
        setItem('userInfo', data)
        return data.token
      })
      .finally(() => { refreshing = null })
  }
  return refreshing
}

// 请求拦截器：注入 token
instance.interceptors.request.use(config => {
  const openId = getCookie('openId')
  // 非白名单的 PC 端禁止访问
  if (openId && !_isMobile() && !whiteList.includes(openId)) {
    alert('كومپيۋتەردە اشۋ ۇقىعى شەكتەلدى. قولفون نۇسقاسى ارقىلى كورىڭىز. راحىمەت.')
    return Promise.reject(new Error('PC 端访问受限'))
  }
  return withToken(config, getItem('userInfo')?.token)
}, error => Promise.reject(error))

// 响应拦截器：解密 + token 过期自动续期并重放原请求
instance.interceptors.response.use(res => handleResult(res.data), async error => {
  const { config, response } = error
  const expired = response?.status === 403 && response.data?.error_code === TOKEN_EXPIRED_CODE

  // 非 token 过期、或已重试过：直接抛出
  if (!expired || !config || config.__retried) return Promise.reject(error)
  config.__retried = true

  try {
    const openId = getCookie('openId')
    if (!openId) throw new Error('缺少 openId')
    const token = await refreshToken(openId)
    return instance(withToken(config, token))
  } catch (refreshErr) {
    // 续期失败（无 openId / 换取失败）：跳微信授权重新登录
    redirectToAuth()
    return Promise.reject(refreshErr)
  }
})

// 请求工具函数
export default instance
